import { INCIDENT_STATUS } from '@silverfort-nodelibs/common/utils/consts';
import { INCIDENT_STATUS_OPTIONS } from '../Filters/FilterOptions';
import { Dropdown } from '@silverfort/sf-components';
import { FC } from 'react';

interface Props {
    status?: string;
    setStatus: (status: number) => void;
}

const StatusColumn: FC<Props> = ({ status = INCIDENT_STATUS.OPEN.label, setStatus }) => {
    const selectedStatus =
        INCIDENT_STATUS_OPTIONS.find((option) => option.title.toUpperCase() === status) ?? INCIDENT_STATUS_OPTIONS[0];

    const onStatusChange = (newStatus?: number | number[]) => {
        if (newStatus !== selectedStatus.value) {
            setStatus(newStatus as number);
        }
    };

    return (
        <Dropdown
            variant="trigger"
            selectedItems={selectedStatus.value}
            items={INCIDENT_STATUS_OPTIONS}
            onChange={onStatusChange}
            size="small"
            className={`w-fit bg-sf-white border hover:bg-sf-primary-100 hover:text-sf-primary-500 hover:color-sf-primary-500`}
        />
    );
};

export default StatusColumn;
